<template>
  <v-dialog
    v-model="isActive"
    max-width="512"
    content-class="rounded-xl ma-2"
    :persistent="loading"
  >
    <template #activator="scopedSlot">
      <slot name="activator" v-bind="scopedSlot" />
    </template>

    <v-card>
      <v-card-title>
        <slot name="title" />
      </v-card-title>

      <v-card-text class="card__text">
        <v-form ref="form" @submit.prevent="$_onConfirm">
          <slot />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn rounded text
          class="pr-3 btn-dialog-confirm"
          :disabled="loading"
          @click="$_onClickCancel"
        >
          <v-icon left>mdi-close</v-icon>
          {{ $t('close') }}
        </v-btn>

        <v-btn rounded depressed
          class="pr-3 custom-btn-dialog-confirm"
          :color="$_confirmBtnOptions.color"
          :dark="$_confirmBtnOptions.dark"
          :disabled="$_confirmBtnOptions.disabled"
          :loading="loading"
          @click="$_onConfirm"
        >
          <v-icon left>{{ $_confirmBtnOptions.icon }}</v-icon>
          {{ $_confirmBtnOptions.label }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogConfirm',

  props: {
    loading: Boolean,
    confirmBtn: Object,
  },

  data() {
    return {
      isActive: false,
    };
  },

  computed: {
    $_confirmBtnOptions() {
      return {
        color: this.confirmBtn?.color ?? 'accent',
        dark: this.confirmBtn?.dark,
        icon: this.confirmBtn?.icon ?? 'mdi-check',
        label: this.confirmBtn?.label ?? this.$t('confirm'),
        disabled: this.confirmBtn?.disabled,
      };
    },
  },

  methods: {
    $_onClickCancel() {
      this.isActive = false;
    },

    $_onConfirm() {
      this.$emit('submit');
    },

    validate(...args) {
      return this.$refs.form.validate(...args);
    },

    reset(...args) {
      return this.$refs.form.reset(...args);
    },

    show() {
      this.isActive = true;
    },

    close() {
      this.isActive = false;
    },
  },

  watch: {
    isActive(value) {
      if (!value) this.$emit('onclose');
    },
  },
};
</script>

<style>
.custom-btn-dialog-confirm.v-btn:not(.v-btn--round).v-size--default {
  padding: 0px 7px 0px 3px !important;
}

.card__text {
  padding-bottom: 0px !important;
}
</style>
